import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-console
      console.error('UI error:', error, info?.componentStack);
    }
  }

  handleReset = () => {
    this.setState({ error: null });
    if (typeof window !== 'undefined') window.location.href = '/';
  };

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-yellow-300 p-6">
          <div className="bg-white border-4 border-black shadow-[12px_12px_0px_rgba(0,0,0,1)] max-w-lg w-full p-8">
            <div className="bg-black text-white px-3 py-1 inline-block font-black uppercase tracking-widest text-xs mb-4">
              SYSTEM_ERROR / 500
            </div>
            <h1 className="text-4xl font-black mb-3 leading-none">Something glitched.</h1>
            <p className="text-sm font-mono opacity-70 mb-6">
              The interface couldn't render that view. The error is logged in the console.
            </p>
            <pre className="bg-gray-100 text-xs p-3 border-2 border-black mb-6 overflow-x-auto max-h-40">
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <button
              onClick={this.handleReset}
              className="w-full bg-yellow-400 text-black py-4 font-black text-lg border-4 border-black shadow-[4px_4px_0px_black] hover:shadow-none hover:translate-x-1 hover:translate-y-1 transition-all uppercase tracking-wider"
            >
              ← Return Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
